 
import { Button } from 'react-bootstrap';
import type { ButtonProps } from 'react-bootstrap';

type SmallButtonProps = ButtonProps;

const SmallButton = ({
  children,
  variant = 'falcon-primary',
  onClick,
  ...props
}: SmallButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      className="d-flex align-items-center justify-content-center"
      style={{
        padding: '3.5px 3.5px'
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SmallButton;
